import type {DefaultError} from "@tanstack/react-query";
import type {UrlQueryKey} from "~/query/queryClient.ts";
import {useCustomQuery} from "~/query/queryClient.ts";
import type {ContractDetail} from "./contractExplorerTypes.ts";
import {contractsUrl} from "./useContractExplorerQueries.ts";

/** `GET /api/data/{databag_id}/contracts/{id}/` */
export const contractDetailUrl = (bagId: number, contractId: number) => `${contractsUrl(bagId)}${contractId}/`;

/** One bundle whole: documents, versions with values, parties, linkage, link counts and spend per line. */
export function useContractDetailQuery(bagId: number, contractId: number) {
    return useCustomQuery<ContractDetail, DefaultError, ContractDetail, UrlQueryKey>({
        queryKey: [contractDetailUrl(bagId, contractId)],
        enabled: bagId > 0 && contractId > 0,
        staleTime: 5 * 60_000,
    });
}
